import { Component, Input, OnInit } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { ImageListComponentContext } from './image-list-context.interface';

@Component({
    selector: 'app-image-list',
    templateUrl: './image-list.component.html',
    styleUrls: ['./image-list.component.min.css'],
})
export class ImageListComponent implements BuildingBlockInterface, OnInit {
    @Input() public context: ImageListComponentContext;
    public columnCount: number;
    public paddingEnabled = true;

    public ngOnInit(): void {
        this.columnCount = this.context.images.length;
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-list/image-list.component.ts